export default function LoadingMsg() {
  return (
    <div className="text-sm flex items-center space-x-2 ">
      <span className="loading loading-dots loading-xs bg-gymmate "></span>

      <p>데이터를 불러오고 있어요</p>
    </div>
  );
}
